export default {
    namespaced: true,
    state: {
        uploadProgressObj: {},
        drawer_visible: false,//是否显示上传文件进度条
    },
    mutations: {
        //添加进度条
        ADD_UPLOAD_PROGRESS: (state, { fileName, ProgressEvent, callback, suspendUpload, continueUpload, is_suspend, sampleId, markFlag, markType, info }) => {
            var key = new Date().getTime()
            state.uploadProgressObj = {
                [key]: {
                    fileName,
                    ProgressEvent,
                    is_suspend,
                    suspendUpload,//暂停
                    continueUpload,//不暂停
                    sampleId,
                    markFlag,
                    markType,
                    info//其它信息  sceneAlgorithmId等
                },
                ...state.uploadProgressObj,
            }
            callback(key)
            console.log("保存的进度条:",state.uploadProgressObj )
        },

        //更新进度
        SET_UPLOAD_PROGRESS: (state, { key, ProgressEvent }) => {
            state.uploadProgressObj = {
                ...state.uploadProgressObj,
                [key]: {
                    ...state.uploadProgressObj[key],
                    ProgressEvent
                }
            }
        },
        
        //设置进度条状态
        SET_UPLOAD_STATUS: (state, { key, is_suspend }) => {
            state.uploadProgressObj = {
                ...state.uploadProgressObj,
                [key]: {
                    ...state.uploadProgressObj[key],
                    is_suspend
                }
            }
        },

        //取消算法上传
        DEL_UPLOAD_PROGRESS: (state, { key }) => {
            var obj = {
                ...state.uploadProgressObj
            }
            obj[key]?.info?.cancelUpload?.()
            setTimeout(() => {
                delete obj[key]
                state.uploadProgressObj = obj
                if (Object.keys(state.uploadProgressObj)?.length == 0) {
                    state.drawer_visible = false
                }
            }, 0);
        },

        //控制是否显示进度条
        SET_DRAWER_VISIBLE(state, value) {
            state.drawer_visible = value
        }
    }
}
